import React, {useEffect, useState} from "react";
import "./MainView.scss"
import DisplayImage from "./DisplayImage";
import {TextDescription, TITLE, API, MAIN_DESCRIPTION} from "../helper/constant";
import CallMissedIcon from '@mui/icons-material/CallMissed';
import MiniBar from "./MiniBar";
import {controlBottom, secControlBottom} from "../actions/profileAction";
import {useDispatch} from "react-redux";
import Loading from "./Loading";

const MainView = () => {

    const [click, setClick] = useState(false)
    const [data, setData] = useState()
    const [secData, setSecData] = useState()
    const [description, setDescription] = useState()
    const [title, setTitle] = useState()
    const [link, setLink] = useState()
    const dispatch = useDispatch()



    useEffect(() => {
        click && controlBottom()(dispatch)
        !click && secControlBottom()(dispatch)
    }, [click])

    return (
        <>


            {
                click &&
                <DisplayImage imageData={data} setClick={setClick} description={description} title={title} link={link}
                              secData={secData}/>

            }
            {
                !click && <MiniBar/>
            }

            {!click &&
            <div className={"mainViewContainer"}>
                <div className={"imageDisplay"}>
                    <div className={"imageLayout"}>
                        <img className={"insideImage"}
                             src="https://i.ibb.co/c6cjC8S/mark2win.png" alt="Break"
                             border="0"
                             onClick={(e) => {
                                 setClick(true)
                                 setData('https://i.ibb.co/zXdDY5q/Mark2win1.png')
                                 setDescription(TextDescription.TEXT_ONE)
                                 setTitle(TITLE.TITLE_ONE)
                                 setSecData(API.API_MARK2WIN)
                                 setLink(API.MARK_WRB)
                             }
                             }
                        />
                        <img className={"insideSecondImage"} src="https://i.ibb.co/fXt5b3p/system.png" alt="Break"
                             border="0"

                             onClick={(e) => {
                                 setClick(true)
                                 setData('https://i.ibb.co/kBXTWwx/system2.png')
                                 setDescription(TextDescription.TEXT_TWO)
                                 setSecData(API.API_SYSTEM)
                                 setTitle(TITLE.TITLE_TWO)

                             }
                             }

                        />
                        <img className={"insideThirdImage"} src="https://i.ibb.co/MfN3QsV/chair.png" alt="Break"
                             border="0"
                             onClick={(e) => {
                                 setClick(true)
                                 setData('https://i.ibb.co/Q9fBBJW/chair2.png')
                                 setDescription(TextDescription.TEXT_THREE)
                                 setSecData(API.API_CHAIR)
                                 setTitle(TITLE.TITLE_THREE)
                                 setLink(API.CHAIR)
                             }
                             }
                        />
                    </div>

                    <div className={'theArrow'}><CallMissedIcon className={'arrow'}/>
                        <img className={'selfImage'} src="https://i.ibb.co/NVgy5Qn/self.png" alt=""/>
                        <div className={'popUp'}>
                            <h1>{MAIN_DESCRIPTION.TITLE_UP}</h1>
                            <h2>{MAIN_DESCRIPTION.FIRST_UP}</h2>
                            <div>{MAIN_DESCRIPTION.SEC_UP}</div>
                        </div>
                    </div>
                </div>

                <div className={"selfDescription"}>
                    <h1>{MAIN_DESCRIPTION.TITLE}</h1>
                    <h2>{MAIN_DESCRIPTION.SECOND_TITLE}</h2>
                    <div>{MAIN_DESCRIPTION.CONTEXT}</div>
                    <div>{MAIN_DESCRIPTION.SEC_CONTEXT}</div>
                </div>


            </div>
            }
        </>
    )
}


export default MainView
